/**
 * Creates a `translate` transformation string with the given offsets.
 *
 * @param x The x translation offset
 * @param y The y translation offset
 */
export const getTranslateTransform = (x: number, y: number): string => `translate(${x}, ${y})`;
